import { GeoJSONGeometry } from 'ol/format/GeoJSON';
import axios from "@/axios-service";
import { ResponseContent, responseContent } from "../types";
import { CarDTO} from "./types";


const MS_URL = "/senana/api/territorio/v1/car";
const responseFindFarm = responseContent(CarDTO);


export const findFarmByLatLong = async (
  long: number, lat: number 
): Promise<ResponseContent<CarDTO>> =>
  axios.get(`${MS_URL}/${lat}/${long}`)
    .then(responseFindFarm);


    export const findFarmByCar = async (
  car: string, 
): Promise<ResponseContent<CarDTO>> =>
  axios.get(`${MS_URL}/${car}`)
    .then(responseFindFarm);

export const findCarsNearByGeom = async (
  long: number, lat: number,
): Promise<ResponseContent<CarDTO>> => 
  axios.post(`${MS_URL}/nearby`, { 
    type: 'Point',
    coordinates: [ long, lat ],
  }).then(responseFindFarm);
